import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Ban, Clock } from 'lucide-react';
import { SuspensionInfo } from '@/hooks/useSuspensionCheck';
import { formatDistanceToNow } from 'date-fns';

interface SuspensionBannerProps {
  suspensionInfo: SuspensionInfo;
}

export function SuspensionBanner({ suspensionInfo }: SuspensionBannerProps) {
  if (!suspensionInfo.isSuspended) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <Ban className="h-4 w-4" />
      <AlertTitle>
        {suspensionInfo.isPermanent ? 'Account Permanently Banned' : 'Account Temporarily Suspended'}
      </AlertTitle>
      <AlertDescription>
        <p className="mb-2">
          {suspensionInfo.reason || 'Your account has been suspended due to community guideline violations.'}
        </p>
        {!suspensionInfo.isPermanent && suspensionInfo.expiresAt && (
          <div className="flex items-center gap-2 text-sm">
            <Clock className="w-4 h-4" />
            <span>
              Your suspension will be lifted in {formatDistanceToNow(new Date(suspensionInfo.expiresAt))}
            </span>
          </div>
        )}
        {suspensionInfo.isPermanent && (
          <p className="text-sm mt-2">
            You can no longer post content or interact with the community. If you believe this was in error, please contact support.
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
}